module.exports = __webpack_public_path__ + "img/tk.9370e8ff.png";